/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PosTransactionRequest } from './PosTransactionRequest';

/**
 * Class used for pos payment request payload.
 */
export type PosTransactionRequestDto = {
    description?: string;
    /**
     * payment option
     */
    paymentOption: PosTransactionRequestDto.paymentOption;
    transaction?: PosTransactionRequest;
};

export namespace PosTransactionRequestDto {

    /**
     * payment option
     */
    export enum paymentOption {
        MONTHLY_FEE = 'MONTHLY_FEE',
        TRANSACTION_FEE = 'TRANSACTION_FEE',
        FULL_PAYMENT = 'FULL_PAYMENT',
    }


}
